import { render, staticRenderFns } from "./ReportStatusOverview.vue?vue&type=template&id=18f417bc"
import script from "./ReportStatusOverview.vue?vue&type=script&lang=js"
export * from "./ReportStatusOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports